import FormatCurrency from 'components/Common/FormatCurrency'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import { useAppSelector } from 'hooks/reduxHooks'
import getLuxPlusTotalValueSaved from 'luxPlus/selectors/benefits/getLuxPlusTotalValueSaved'
import { FormattedMessage } from 'react-intl'
import { getBaseTierOfferWithJoiningFee } from 'selectors/luxPlusSelectors'

function LuxPlusManageAccountModalSavingsBanner() {
  const totalValueSaved = useAppSelector(getLuxPlusTotalValueSaved)
  const subscriptionOffer = useAppSelector(getBaseTierOfferWithJoiningFee)

  if (!subscriptionOffer || totalValueSaved < subscriptionOffer.price) return null

  return <MessageBanner
    kind="promotional-primary"
    density="compact"
    icon={<LineUsdCircleIcon />}
  >
    <FormattedMessage
      id="OLT1nqJn-xsDpL83peGp"
      defaultMessage="You’ve <bold>saved {savings}</bold> since joining"
      description="Banner message showing total savings since joining LuxPlus+ membership"
      values={{
        savings: <FormatCurrency value={totalValueSaved} />,
        bold: (chunks) => <b>{chunks}</b>,
      }}
    />
  </MessageBanner>
}

export default LuxPlusManageAccountModalSavingsBanner
